import React from 'react';
import './App.css';
import logos from './logos.svg';
import users from './users.svg';
import firebase from "firebase/app";
import { Component,  useRef, createContext, useState, useEffect, useContext, useCallback, Suspense, createRef  }  from 'react';
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";


export default function PostInfo () {
	return(
		<p>this is the info page for this post</p>)}